import type { JiraIssueSearchOperationScope } from '@atlassian/jira-issue-navigator/src/__generated__/main_IssueNavigatorQuery.graphql';
import { NIN_PROJECT_OPERATION_SCOPE, NIN_GLOBAL_OPERATION_SCOPE } from '../constants.tsx';

export const getOperationScope = (projectKey?: string | null): JiraIssueSearchOperationScope => {
	let operationScope: JiraIssueSearchOperationScope;

	if (projectKey != null) {
		operationScope = NIN_PROJECT_OPERATION_SCOPE;
	} else {
		operationScope = NIN_GLOBAL_OPERATION_SCOPE;
	}

	return operationScope;
};
